import type { PropsWithChildren } from "react";
import { cx } from "@/utils/cx";

type FilterPanelContainerProps = {
  open: boolean;
} & PropsWithChildren;

export const FilterPanelContainer = ({ open, children }: FilterPanelContainerProps) => (
  <div
    className={cx(
      "fixed right-0 w-96 bg-secondary border-l border-secondary z-50",
      "transform transition-transform duration-300 ease-in-out",
      open ? "translate-x-0" : "translate-x-full",
    )}
    style={{
      top: "var(--sidebar-top-offset, 0px)",
      height: "calc(100vh - var(--sidebar-top-offset, 0px))",
    }}
  >
    <div className="flex flex-col h-full">{children}</div>
  </div>
);
